import { graphql } from "react-relay";

export const DELETE_PERSONALIZED_NOTIFICATION_TEMPLATE_MUTATION = graphql`
	mutation deletePersonalizedNotificationTemplateButton_DeletePersonalizedNotificationTemplateMutation(
		$input: DeletePersonalizedNotificationTemplateInput!
		$connections: [ID!]!
	) {
		Admin {
			Notification {
				deletePersonalizedNotificationTemplate(input: $input) {
					deletedId @deleteEdge(connections: $connections)
				}
			}
		}
	}
`;
